/**
 * Metpure Met Pro Wholesale Page Script
 * Simple, clean interaction handlers for FAQ accordion, video modal, and smooth scrolling
 */

document.addEventListener('DOMContentLoaded', function () {
  initMetproFaq();
  initMetproVideoModal();
  initMetproSmoothScroll();
});

/**
 * FAQ Accordion Toggle
 */
function initMetproFaq() {
  const faqTriggers = document.querySelectorAll('.js-metpro-faq-trigger');

  faqTriggers.forEach((trigger) => {
    trigger.addEventListener('click', function () {
      const parentRow = this.closest('.metpro-faq-row');
      if (!parentRow) return;

      const isOpen = parentRow.classList.contains('is-active');
      const container = parentRow.closest('.metpro-faq-accordion');

      // Close other rows in accordion
      if (container) {
        container.querySelectorAll('.metpro-faq-row.is-active').forEach((activeRow) => {
          if (activeRow !== parentRow) {
            activeRow.classList.remove('is-active');
            const btn = activeRow.querySelector('.js-metpro-faq-trigger');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });
      }

      // Toggle current row
      if (isOpen) {
        parentRow.classList.remove('is-active');
        this.setAttribute('aria-expanded', 'false');
      } else {
        parentRow.classList.add('is-active');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/**
 * Video Modal Lightbox
 */
function initMetproVideoModal() {
  const videoTriggers = document.querySelectorAll('.js-metpro-video-trigger');
  const modal = document.getElementById('MetproVideoModal');
  if (!modal) return;

  const closeBtn = modal.querySelector('.js-metpro-modal-close');
  const iframe = modal.querySelector('iframe');
  const baseSrc = iframe ? iframe.getAttribute('data-src') || iframe.src : '';

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    if (iframe && baseSrc) {
      const sep = baseSrc.includes('?') ? '&' : '?';
      iframe.src = baseSrc + sep + 'autoplay=1';
    }
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    if (iframe) {
      iframe.src = '';
      setTimeout(() => {
        iframe.src = baseSrc;
      }, 100);
    }
  }

  videoTriggers.forEach((trigger) => {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openModal();
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeModal();
    });
  }

  modal.addEventListener('click', function (e) {
    if (e.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
}

/**
 * Smooth Scroll to Form
 */
function initMetproSmoothScroll() {
  const scrollButtons = document.querySelectorAll('a[href^="#metpro-form"]');

  scrollButtons.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId && targetId !== '#') {
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    });
  });
}
